import { ObjectHelper } from "@swivl-mono/helpers";
import { BrandInterface, GroupInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Brand/Brand.Controller.ts
export class BrandsAPI {
  static async getBrands(orgId: number, includeArchived = false) {
    return APIService.Server.get<BrandInterface[]>(`/brands/org/${orgId}`, includeArchived ? { includeArchived: true } : undefined);
  }
  static async getBrand(orgId: number, brandId: number) {
    return APIService.Server.get<BrandInterface>(`/brands/org/${orgId}/brand/${brandId}`);
  }
  static async createBrand(orgId: number, brand: Partial<BrandInterface>) {
    return APIService.Server.post<BrandInterface>(`/brands/org/${orgId}/brand`, brand);
  }
  static async updateBrand(orgId: number, brand: BrandInterface) {
    return APIService.Server.put<BrandInterface>(`/brands/org/${orgId}/brand/${brand.id}`, ObjectHelper.stripNulls(brand));
  }
  /** Partial update (Snowy Brands page autosave) — sends only the changed fields, nulls included. */
  static async patchBrand(orgId: number, brandId: number, patch: Partial<BrandInterface>) {
    return APIService.Server.put<BrandInterface>(`/brands/org/${orgId}/brand/${brandId}`, patch);
  }
  static async deleteBrand(orgId: number, brandId: number) {
    return APIService.Server.delete(`/brands/org/${orgId}/brand/${brandId}`);
  }
  static async restoreBrand(orgId: number, brandId: number) {
    return APIService.Server.post<BrandInterface>(`/brands/org/${orgId}/brand/${brandId}/restore`, {});
  }
  static async duplicateBrand(orgId: number, brandId: number) {
    return APIService.Server.post<BrandInterface>(`/brands/org/${orgId}/brand/${brandId}/duplicate`, {});
  }
}
